
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blur-text-in-image",
      function () {
        return require("private-next-pages/blur-text-in-image/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blur-text-in-image"])
      });
    }
  